module.exports = {"username":"demo.kppbc4","id":"9","group":"beacukai","status":"enabled","detil":{"nama":"Demo Kppbc 4","nip":"723662782992932939","pangkat":"Pengatur Tk. I - II/d","kode_eselon2":"160000","eselon2":"Kanwil DJBC Jawa Timur II","kode_eselon3":"070600","eselon3":"KPPBC TMC MALANG","kantor":"KPPBC TMC MALANG","kantor_id":"070600","kantor_level":"eselon3"},"roleInfo":{"siroleg":[{"role":"siroleg.bc.analis","role_name":"Analis Beacukai","name":"siroleg","domains":"siroleg.beacukai.go.id","description":"Siroleg","icon":null}]}}


//////////////////
// WEBPACK FOOTER
// ./src/router/fake_tokens/token_kppbc4.json
// module id = YUbO
// module chunks = 10